import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GroupedBarGraph } from '@app/interfaces/IGraphStyle';

@Component({
  selector: 'app-grouped-bar-chart',
  templateUrl: './grouped-bar-chart.component.html',
  styleUrls: ['./grouped-bar-chart.component.scss']
})
export class GroupedBarChartComponent {
  @Input() data: any = []; // data coming from parent components
  @Input() style: GroupedBarGraph;// style values to be passed from parent components
  @Output() barClickEvent = new EventEmitter<string>(); //output event emitter required for performing click event

  colorScheme: any = {
    domain: ['#8CC7F7', '#F99698', '#A8D5A0', '#F6DF87']
  };


  ngOnInit() {

  }

  /**
   * on click of button it will emit the data.
   * @param data
   */
  onSelect(data: any): void {
    this.barClickEvent.emit(data);
  }
}

